export default __webpack_public_path__ + "static/media/revoke-big.c98082b4.svg";